var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_ENV } = process.env;
import { FILTER_SEARCH_MESSAGE_MAP, ORDER_TIME_TYPE, SEARCH_FROM, } from "src/utils/constant";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import InfiniteScroll from "react-infinite-scroll-component";
import { createSearchParams, useNavigate } from "react-router-dom";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { getElasticSearchDataNew } from "../../apis/dashboard";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { onModalOpenClose, openAddToWatchlistModal, openBuySellModal, } from "../../redux/reducers/modals";
import { stockInfoData } from "../../redux/reducers/stock-info-Reducer";
import { getChangeAndChangePercentage, getDisplayTextFromExchange, getExhangeColor, getExhangeTypeColor, getFormattedDate, getPreferences, getStockNameFromSearchData, openChartTab, parseSearchstring, setPreferences, } from "../../utils/methods";
import { heartBeatData, subscribeToData, unsubscribeDataBySubscriber, } from "../../utils/websocketwrapper";
import ActivateSegment from "../activate-segment/activate-segment";
import Loader from "../loader/loader";
import styles from "./search.module.scss";
import SingleSearchRow from "./singleSearchRow";
import { CHART_DATE_FORMAT } from "src/utils/constant";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
const SearchModule = ({ basketData, toggleModal, searchFrom, queryString, closeSearch, }) => {
    const dispatch = useAppDispatch();
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const openFeedWsMsg = useAppSelector((state) => state.openFeedWs.message);
    const [scripList, setScripList] = useState([]);
    const [scripPriceData, setScripPriceData] = useState([]);
    const [componentName] = useState(() => "SearchModule");
    const [clientCode] = useState(() => getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
    const [hasMoreSearchData, setHasMoreSearchData] = useState(true);
    const [apiLoading, setApiLoading] = useState(true);
    const myPreferences = getPreferences();
    const [selectedSearchTab, setSelectedSearchTab] = useState(myPreferences.search.selectedScrip);
    const defaultKeyTab = selectedSearchTab;
    const getElasticData = (isScroll, filterString, apiFirstLoad) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (apiFirstLoad == true) {
                setApiLoading(true);
            }
            if (queryString.length > 2) {
                // const response = await getElasticSearchDataNew(
                //   parseSearchstring(queryString),
                //   scripList.length,
                //   filterString || ""
                // );
                if (!isScroll) {
                    scripList.length = 0;
                }
                const response = yield getElasticSearchDataNew(parseSearchstring(queryString), scripList.length, filterString || "");
                response.data.value.length < 10
                    ? setHasMoreSearchData(false)
                    : setHasMoreSearchData(true);
                if (isScroll) {
                    const totalResponse = [...scripList].concat(response.data.value);
                    const setData = getFilteredVttData(totalResponse);
                    setScripList(setData);
                }
                else {
                    unsubscribeDataBySubscriber(componentName);
                    const setData = getFilteredVttData(response.data.value);
                    setScripList(setData);
                }
                captureCleverTabAnalytics("Search Bar event text - Search Bar - FNO", {
                    SearchValue: queryString,
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setApiLoading(false);
        }
    });
    // useEffect(() => {
    //   setScripList([]);
    // }, [queryString.length]);
    const getFilteredVttData = (arrayData) => {
        let filteredData = [...arrayData];
        if (searchFrom === SEARCH_FROM.VTT) {
            const data = filteredData.filter((item) => {
                return item.ExchType !== "U" && item.Exch !== "M";
            });
            filteredData = [...data];
        }
        return filteredData;
    };
    useEffect(() => {
        getElasticData(false, FILTER_SEARCH_MESSAGE_MAP[selectedSearchTab], true);
    }, [queryString]);
    useEffect(() => {
        if (!queryString) {
            setScripList([]);
        }
    }, [queryString]);
    const sendWsMessage = useCallback((heartBeatMessage) => {
        if (scripList.length == 0) {
            return;
        }
        let listVtt;
        if (searchFrom === SEARCH_FROM.VTT) {
            listVtt = scripList
                .filter((singleScript) => singleScript.ExchType !== "U" && singleScript.Exch !== "M")
                .map((singleScrip) => {
                return {
                    Exch: singleScrip.Exch,
                    ExchType: singleScrip.ExchType,
                    ScripCode: singleScrip.ScripCode,
                };
            });
        }
        else {
            listVtt = scripList.map((singleScrip) => {
                return {
                    Exch: singleScrip.Exch,
                    ExchType: singleScrip.ExchType,
                    ScripCode: singleScrip.ScripCode,
                };
            });
        }
        const method1 = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: listVtt,
        };
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
        }
    }, [scripList]);
    useEffect(() => {
        // const newPriceData: ScriptDataType[] = [];
        // scripList.forEach((singleIndex) => {
        //   newPriceData.push({
        //     Token: parseInt(singleIndex.ScripCode + ""),
        //     PClose: 0,
        //     Expiry: "",
        //     LastRate: 0,
        //     TotalQty: 0,
        //   });
        // });
        // setScripPriceData(newPriceData);
        // unsubscribeDataBySubscriber(componentName);
        sendWsMessage(openFeedWsHeartBeat);
    }, [openFeedWsHeartBeat, scripList]);
    useEffect(() => {
        if (openFeedWsMsg) {
            updateOptionChain(openFeedWsMsg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openFeedWsMsg]);
    const updateOptionChain = useCallback((update) => {
        const newScripDetails = [...scripPriceData];
        if (Array.isArray(update)) {
            update = update[0];
        }
        let isPriceUpdated = false;
        if ((update === null || update === void 0 ? void 0 : update.Details) === undefined && (update === null || update === void 0 ? void 0 : update.OpenInterest) === undefined) {
            newScripDetails.forEach((singleScrip) => {
                if (singleScrip.ScripCode === (update === null || update === void 0 ? void 0 : update.Token)) {
                    singleScrip.LastRate = update.LastRate;
                    singleScrip.PClose = update.PClose;
                    isPriceUpdated = true;
                }
            });
            if (!isPriceUpdated) {
                scripList.forEach((singleScrip) => {
                    if (singleScrip.ScripCode === (update === null || update === void 0 ? void 0 : update.Token)) {
                        const singleScripClone = Object.assign({}, singleScrip);
                        singleScripClone.LastRate = update.LastRate;
                        singleScripClone.PClose = update.PClose;
                        newScripDetails.push(singleScripClone);
                        isPriceUpdated = true;
                    }
                });
            }
            if (isPriceUpdated) {
                setScripPriceData(newScripDetails);
            }
        }
    }, [scripList, scripPriceData]);
    // Add To Basket on Search
    const openAddToBasket = useCallback((isBuy, singleScript, priceData) => {
        let stockType = "FUT";
        if (singleScript.CPTypeText == "PUT") {
            stockType = "PE";
        }
        else if (singleScript.CPTypeText == "CALL") {
            stockType = "CE";
        }
        else if (singleScript.ExchType == "C") {
            stockType = "CASH";
        }
        else {
            stockType = "FUT";
        }
        let stockName = singleScript.Name;
        if (stockType == "FUT") {
            stockName =
                singleScript.ShortName +
                    " FUT " +
                    moment(singleScript.ExpiryDate).format("DD MMM YY");
        }
        const data = {
            isBuy,
            name: getStockNameFromSearchData(singleScript),
            exchange: singleScript.Exch,
            exchangeType: singleScript.ExchType,
            scripCode: singleScript.ScripCode,
            lastTradePrice: priceData.LastRate,
            previousClose: priceData.PClose,
            orderFor: "P",
            isBasket: true,
            openedFrom: searchFrom === "basket" ? "Footer Basket" : "",
            basketIds: basketData ? [{ BasketID: basketData === null || basketData === void 0 ? void 0 : basketData.BasketId }] : undefined,
        };
        captureCleverTabAnalytics("Basket_Click", {
            Action: "Basket_Icon",
            Initiation_Screen: "Search",
        });
        toggleModal();
        dispatch(openBuySellModal(data));
        closeSearch();
    }, []);
    const buySellCallback = useCallback((isBuy, singleScript, priceData) => {
        const data = {
            isBuy,
            name: getStockNameFromSearchData(singleScript),
            exchange: singleScript.Exch,
            exchangeType: singleScript.ExchType,
            scripCode: singleScript.ScripCode,
            lastTradePrice: priceData === null || priceData === void 0 ? void 0 : priceData.LastRate,
            previousClose: priceData === null || priceData === void 0 ? void 0 : priceData.PClose,
            orderFor: "P",
            isBasket: false,
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            timeType: searchFrom === ORDER_TIME_TYPE.VTT
                ? ORDER_TIME_TYPE.VTT
                : ORDER_TIME_TYPE.REGULAR,
            openedFrom: "Search",
        };
        captureCleverTabAnalytics("Buy/Sell form opened - Searchbar - FNO", {
            StockName: data.name,
            ExchangeType: data.exchangeType,
            // ScripCode: data.toString(),
            ScripCode: data.scripCode,
        });
        dispatch(openBuySellModal(data));
        closeSearch();
    }, []);
    const onAddToWatchlist = useCallback((singleData) => {
        const payload = {
            Exch: singleData.Exch,
            ExchType: singleData.ExchType,
            ScripCode: singleData.ScripCode,
            name: getStockNameFromSearchData(singleData),
        };
        dispatch(openAddToWatchlistModal(payload));
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "open" }));
        closeSearch();
    }, []);
    //unmount effect
    useEffect(() => {
        return () => {
            //unmount call here
            unsubscribeDataBySubscriber(componentName);
        };
    }, []);
    const onChartIconClick = (singleData) => {
        // getScripType(singleData.fullName, singleData.exchange, singleData.exchType);
        const chartData = {
            fullName: singleData.Name,
            strikePrice: singleData.StrikeRate == ""
                ? undefined
                : parseFloat(singleData.StrikeRate),
            exchange: singleData.Exch,
            exchangeType: singleData.ExchType,
            expiry: getFormattedDate(singleData.ExpiryDate, CHART_DATE_FORMAT),
            symbol: singleData.IndexId !== -1
                ? singleData.Name.replaceAll(" ", "")
                : singleData.Name.split(" ")[0],
            scripCode: singleData.ScripCode,
        };
        captureCleverTabAnalytics("Screen_Open", {
            Action: "Charts",
            Initiation_Screen: "Search",
        });
        openChartTab(chartData);
        closeSearch();
    };
    const navigate = useNavigate();
    const stockInfoPage = (singleScript, priceData) => {
        const data = {
            symbol: singleScript === null || singleScript === void 0 ? void 0 : singleScript.Name,
            exchange: singleScript === null || singleScript === void 0 ? void 0 : singleScript.Exch,
            exchangeType: singleScript === null || singleScript === void 0 ? void 0 : singleScript.ExchType,
            scripCode: singleScript === null || singleScript === void 0 ? void 0 : singleScript.ScripCode,
            lastTradePrice: priceData === null || priceData === void 0 ? void 0 : priceData.LastRate,
            previousClose: priceData === null || priceData === void 0 ? void 0 : priceData.PClose,
            expiry: singleScript === null || singleScript === void 0 ? void 0 : singleScript.ExpiryDate,
            StrikeRate: singleScript === null || singleScript === void 0 ? void 0 : singleScript.StrikeRate,
            indexId: singleScript === null || singleScript === void 0 ? void 0 : singleScript.IndexId,
        };
        const params = data;
        navigate({
            pathname: "/stock-info",
            search: `?${createSearchParams(params)}`,
        });
        dispatch(stockInfoData(data));
        setScripList([]);
        closeSearch();
    };
    const fetchMoreData = () => {
        getElasticData(true, FILTER_SEARCH_MESSAGE_MAP[selectedSearchTab], false);
    };
    const userDetails = getDataFromSession(SESSION_KEYS.USERMARKETENABLED) || {};
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: `${styles.searchModuleWrapper} ${searchFrom == SEARCH_FROM.VTT && styles.VttModuleWrapper} ${searchFrom == SEARCH_FROM.BASKET && styles.basketModuleWrapper}` }, { children: queryString.length > 2 ? (_jsxs(_Fragment, { children: [_jsxs(Tabs, Object.assign({ defaultActiveKey: defaultKeyTab, onSelect: (eventKey) => {
                            getElasticData(false, FILTER_SEARCH_MESSAGE_MAP[eventKey || ""], true);
                            setSelectedSearchTab(eventKey !== null && eventKey !== void 0 ? eventKey : "");
                            myPreferences.search.selectedScrip = eventKey !== null && eventKey !== void 0 ? eventKey : "all";
                            setPreferences(myPreferences);
                        }, className: `${styles.globalSearchTab} ${searchFrom == SEARCH_FROM.VTT && styles.VttSearchTab} ${searchFrom == SEARCH_FROM.BASKET && styles.basketSearchTab} stockInfoTabs` }, { children: [_jsx(Tab, { eventKey: "all", title: "All" }), _jsx(Tab, { eventKey: "fno", title: "FNO" }), _jsx(Tab, { eventKey: "equity", title: "Equity" }), searchFrom !== SEARCH_FROM.VTT && (_jsx(Tab, { eventKey: "currency", title: "Currency" })), searchFrom !== SEARCH_FROM.VTT && (_jsx(Tab, { eventKey: "commodity", title: "Commodity" }))] })), apiLoading ? (_jsx("div", Object.assign({ style: { minHeight: "247px" } }, { children: _jsx(Loader, {}) }))) : scripList.length > 0 ? (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ id: "scrollableDiv", style: {
                                    maxHeight: 247,
                                    // width: 540,
                                    overflow: "auto",
                                    // display: "flex",
                                    // flexDirection: "column-reverse",
                                } }, { children: _jsx(InfiniteScroll, Object.assign({ dataLength: scripList.length, next: () => fetchMoreData(), hasMore: hasMoreSearchData, 
                                    // initialScrollY={0}
                                    // scrollThreshold={0.5}
                                    loader: hasMoreSearchData === true ? _jsx(Loader, {}) : "", scrollableTarget: "scrollableDiv" }, { children: _jsx("table", Object.assign({ className: `${styles.globalSearchResultTable}` }, { children: scripList.map((singleScript, index) => {
                                            var _a, _b;
                                            const exhange = getDisplayTextFromExchange(singleScript.Exch, singleScript.ExchType);
                                            let stockType = "";
                                            if (singleScript.CPTypeText == "PUT") {
                                                stockType = "PE";
                                            }
                                            else if (singleScript.CPTypeText == "CALL") {
                                                stockType = "CE";
                                            }
                                            else if (singleScript.ExchType == "C") {
                                                singleScript.StrikeRate = "";
                                                singleScript.ExpiryDate = "";
                                                stockType = "CASH";
                                            }
                                            else {
                                                singleScript.StrikeRate = "";
                                                stockType = "FUT";
                                            }
                                            const exchangeColor = getExhangeColor(exhange);
                                            const exchangeTypeColor = getExhangeTypeColor(stockType);
                                            const priceData = scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.filter((singleScripPrice) => {
                                                if (singleScripPrice.ScripCode ===
                                                    singleScript.ScripCode) {
                                                    return singleScripPrice;
                                                }
                                            });
                                            let valueChangeAndPercentage;
                                            if (priceData) {
                                                valueChangeAndPercentage =
                                                    getChangeAndChangePercentage((_a = priceData[0]) === null || _a === void 0 ? void 0 : _a.LastRate, (_b = priceData[0]) === null || _b === void 0 ? void 0 : _b.PClose);
                                            }
                                            else {
                                                valueChangeAndPercentage = {
                                                    differenceValue: "",
                                                    differencePercentage: "",
                                                    isNegative: false,
                                                };
                                            }
                                            return (_jsx(_Fragment, { children: _jsx(SingleSearchRow, { toggleModal: toggleModal, searchFrom: searchFrom, index: index, singleScript: singleScript, priceData: priceData, stockType: stockType, exchangeTypeColor: exchangeTypeColor, exchangeColor: exchangeColor, valueChangeAndPercentage: valueChangeAndPercentage, stockInfoPage: stockInfoPage, onChartIconClick: onChartIconClick, onAddToWatchlist: onAddToWatchlist, openAddToBasket: openAddToBasket, buySellCallback: buySellCallback }) }));
                                        }) })) })) })), userDetails && (userDetails === null || userDetails === void 0 ? void 0 : userDetails.AllowNseDeriv) == "N" && (_jsx(ActivateSegment, {}))] })) : (_jsxs("div", Object.assign({ className: `${styles.noRecordFound} ${searchFrom == SEARCH_FROM.VTT && styles.noRecordFoundVTT} ${searchFrom == SEARCH_FROM.BASKET && styles.noRecordFoundBasket} flex-column py-4` }, { children: [_jsx("span", { className: "sallyImage" }), _jsx("h6", Object.assign({ className: "w-100 py-3 boldWeight large" }, { children: "No Records Found !" }))] })))] })) : (false) })) }));
};
export default SearchModule;
